import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://modularobjects.com";

const API = `${API_BASE}/marketing/api/erp`;

function authHeader(token) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export async function fetchSupplierItems(token, params = {}) {
  const res = await axios.get(`${API}/supplier-items`, {
    ...authHeader(token),
    params,
  });
  return res.data;
}

export async function fetchSupplierItemById(token, id) {
  const res = await axios.get(`${API}/supplier-items/${id}`, authHeader(token));
  return res.data;
}

export async function createSupplierItem(token, data) {
  const res = await axios.post(`${API}/supplier-items`, data, authHeader(token));
  return res.data;
}

export async function updateSupplierItem(token, id, data) {
  const res = await axios.patch(
    `${API}/supplier-items/${id}`,
    data,
    authHeader(token)
  );
  return res.data;
}

export async function fetchSupplierItemPrices(token, id) {
  const res = await axios.get(
    `${API}/supplier-items/${id}/prices`,
    authHeader(token)
  );
  return res.data;
}

export async function addSupplierItemPrice(token, id, data) {
  const res = await axios.post(
    `${API}/supplier-items/${id}/prices`,
    data,
    authHeader(token)
  );
  return res.data;
}

export async function updateSupplierItemPrice(token, priceId, data) {
  const res = await axios.patch(
    `${API}/supplier-item-prices/${priceId}`,
    data,
    authHeader(token)
  );
  return res.data;
}

export async function setPreferredSupplierItem(token, id) {
  const res = await axios.post(
    `${API}/supplier-items/${id}/set-preferred`,
    {},
    authHeader(token)
  );
  return res.data;
}

export async function fetchSourcingByItem(token, itemId) {
  const res = await axios.get(
    `${API}/sourcing/by-item/${itemId}`,
    authHeader(token)
  );
  return res.data;
}